import { FC } from "react";
import { HiOutlineShare } from "react-icons/hi";
import { News } from "@components/Icons";
import { NewsItem } from "@modules/for-you/types";
import Toast from "@common/components/Toast";
import { useNewsListItem } from "@modules/for-you/hooks";
import { Typography } from "@earned/core";
import { themeTextColors } from "@common/constants";

export interface NewsListItemProps {
  newsItem: NewsItem;
}

const NewsListItem: FC<NewsListItemProps> = ({ newsItem }) => {
  const { copyNewsURLToClipboard, linkToNewsWebsite, formattedDate } =
    useNewsListItem(newsItem);

  return (
    <div className="flex min-h-[232px] min-w-[210px] flex-col justify-between space-y-3 rounded border border-green-200 bg-white p-4">
      <div
        className="flex cursor-pointer flex-col justify-between gap-3"
        onClick={linkToNewsWebsite}
      >
        <div className="flex flex-row items-center gap-2">
          <News height={24} width={24} />
          <Typography variant="body" color="secondary">
            Curated News
          </Typography>
        </div>
        <Typography variant="body" weight="medium" color="primary">
          <span className="line-clamp-2">{newsItem.NAME}</span>
        </Typography>
        <Typography variant="body" color="secondary">
          <span className="line-clamp-3">{newsItem.DESCRIPTION}</span>
        </Typography>
      </div>
      <div className="flex flex-row items-center gap-4">
        <Typography variant="body-xs" color="secondary">
          {formattedDate}
        </Typography>
        <Toast message="PDF link copied to clipboard!" placement="top">
          <div
            className="flex flex-row items-center gap-2"
            onClick={copyNewsURLToClipboard}
          >
            <HiOutlineShare size={16} color={themeTextColors.secondary} />
            <Typography variant="body-xs" color="primary">
              Share
            </Typography>
          </div>
        </Toast>
      </div>
    </div>
  );
};

export default NewsListItem;
